var isSymbol = function isSymbol(value) {
  return !!value && value.constructor === Symbol;
};
var isArray = function isArray(value) {
  return !!value && value.constructor === Array;
};
var isObject = function isObject(value) {
  return !!value && value.constructor === Object;
};
var isPrimitive = function isPrimitive(value) {
  return value === void 0 || value === null || typeof value !== "object" && typeof value !== "function";
};
var isFunction = function isFunction(value) {
  return !!(value && value.constructor && value.call && value.apply);
};
var isString = function isString(value) {
  return typeof value === "string" || value instanceof String;
};
var isInt = function isInt(value) {
  return isNumber(value) && value % 1 === 0;
};
var isFloat = function isFloat(value) {
  return isNumber(value) && value % 1 !== 0;
};
var isNumber = function isNumber(value) {
  try {
    return Number(value) === value;
  } catch (_unused) {
    return false;
  }
};
var isDate = function isDate(value) {
  return Object.prototype.toString.call(value) === "[object Date]";
};
var isEmpty = function isEmpty(value) {
  if (value === true || value === false) return true;
  if (value === null || value === void 0) return true;
  if (isNumber(value)) return value === 0;
  if (isDate(value)) return isNaN(value.getTime());
  if (isFunction(value)) return false;
  if (isSymbol(value)) return false;
  var length = value.length;
  if (isNumber(length)) return length === 0;
  var size = value.size;
  if (isNumber(size)) return size === 0;
  var keys = Object.keys(value).length;
  return keys === 0;
};
var isEqual = function isEqual(x, y) {
  if (Object.is(x, y)) return true;
  if (x instanceof Date && y instanceof Date) {
    return x.getTime() === y.getTime();
  }
  if (x instanceof RegExp && y instanceof RegExp) {
    return x.toString() === y.toString();
  }
  if (typeof x !== "object" || x === null || typeof y !== "object" || y === null) {
    return false;
  }
  var keysX = Reflect.ownKeys(x);
  var keysY = Reflect.ownKeys(y);
  if (keysX.length !== keysY.length) return false;
  for (var i = 0; i < keysX.length; i++) {
    if (!Reflect.has(y, keysX[i])) return false;
    if (!isEqual(x[keysX[i]], y[keysX[i]])) return false;
  }
  return true;
};
export { isArray, isDate, isEmpty, isEqual, isFloat, isFunction, isInt, isNumber, isObject, isPrimitive, isString, isSymbol };